import React from "react";
import "./WhyUs.css";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import ClassIcon from "@mui/icons-material/Class";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import whyus1 from "./WhyUsImages/image1.jpg";
import whyus2 from "./WhyUsImages/image2.jpg";
import whyus3 from "./WhyUsImages/image3.jpg";
import whyus4 from "./WhyUsImages/image4.jpg";
import InterpreterModeIcon from "@mui/icons-material/InterpreterMode";
function WhyUs() {
  return (
    <div className="whyUs">
      <div className="whyus__right">
        <div>
          <img src={whyus1} alt="" />
        </div>
        <div>
          {" "}
          <img src={whyus2} alt="" />
        </div>
        <div>
          <img src={whyus3} alt="" />
        </div>
        <div>
          {" "}
          <img src={whyus4} alt="" />
        </div>
      </div>
      <div dir="rtl" className="whyus__left">
        <h1>لماذا تختار أكاديمية توستوس؟</h1>
        <p className="firstPara">
          في عوض متفرج ساعتین في لایف باش تفھم درس واحد، المنصة كتقدم دروس مدتھا
          لا تتجاوز 12 دقیقة كحد أقصى مع تصحیح التمارین.
        </p>
        <div className="whyus__benefit">
          <AccountBoxIcon className="whyus__icon" />
          <p>التواصل مباشرة مع الأستاذ في أي وقت.</p>
        </div>
        <div className="whyus__benefit">
          <CalendarMonthIcon className="whyus__icon" />
          <p>الإستفادة من ملخص الدرس بصيغة pdf.</p>
        </div>
        <div className="whyus__benefit">
          <LocalLibraryIcon className="whyus__icon" />
          <p>الاشتغال على تمارين داخل القسم وإمتحانات وطنية.</p>
        </div>
        <div className="whyus__benefit">
          <Diversity3Icon className="whyus__icon" />

          <p>حصص مباشرة كل أسبوع لحل المشاكل التي تواجه التلمیذ</p>
        </div>
        <div className="whyus__benefit">
          <MenuBookIcon className="whyus__icon" />
          <p> منھجیات جاھزة تساعد التلمیذ على الكتابة بشكل احترافي.</p>{" "}
        </div>

        <div className="whyus__benefit">
          <CrisisAlertIcon className="whyus__icon" />
          <p>بلا زیادة بلا نقصان, غتلقى غي داكشي لي عندك في الإمتحان.</p>
        </div>

        <div className="whyus__benefit">
          <AttachMoneyIcon className="whyus__icon" />
          <p>أثمنة جد مناسبة في متناول الجميع.</p>
        </div>
       
        <a href="#pricing">
          <button className="enrollbtn">إشترك الآن</button>
        </a>
      </div>
    </div>
  );
}

export default WhyUs;
